import { UserRoleEnum } from "../../src/enums/user";

export function is_user_role(role: unknown): role is UserRoleEnum {
  return (
    typeof role === "string" &&
    Object.keys(UserRoleEnum).includes(role as any)
  );
}
